"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PendoActionType = void 0;
exports.requestInitializePendo = requestInitializePendo;
var PendoActionType;
(function (PendoActionType) {
    PendoActionType["RequestInitialize"] = "requestInitializePendo";
})(PendoActionType || (exports.PendoActionType = PendoActionType = {}));
function requestInitializePendo(account, visitor) {
    return {
        account,
        type: PendoActionType.RequestInitialize,
        visitor
    };
}
//# sourceMappingURL=actions.js.map